var _defineStyle, _defineStyle2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/form-control.ts
import { formAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";

var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
    definePartsStyle = _createMultiStyleConf.definePartsStyle,
    defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;

var $fg = cssVar("form-control-color");
var baseStyleRequiredIndicator = defineStyle((_defineStyle = {
  marginStart: "1"
}, _defineProperty(_defineStyle, $fg.variable, "colors.red.500"), _defineProperty(_defineStyle, "_dark", _defineProperty({}, $fg.variable, "colors.red.300")), _defineProperty(_defineStyle, "color", $fg.reference), _defineStyle));
var baseStyleHelperText = defineStyle((_defineStyle2 = {
  mt: "2"
}, _defineProperty(_defineStyle2, $fg.variable, "colors.gray.600"), _defineProperty(_defineStyle2, "_dark", _defineProperty({}, $fg.variable, "colors.whiteAlpha.600")), _defineProperty(_defineStyle2, "color", $fg.reference), _defineProperty(_defineStyle2, "lineHeight", "normal"), _defineProperty(_defineStyle2, "fontSize", "sm"), _defineStyle2));
var baseStyle = definePartsStyle({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: baseStyleRequiredIndicator,
  helperText: baseStyleHelperText
});
var formTheme = defineMultiStyleConfig({
  baseStyle: baseStyle
});
export { formTheme };